import React, {useContext} from "react";
import {observer} from "mobx-react";
import {Block, Button, Col, Row, Typography} from "@bezlimit/bezlimit-ui";
import {useTranslation} from "react-i18next";
import "./style.scss";
import {LayoutContext} from "../../../../core/Contexts";
import _ from "lodash";
import imgRedirect from "../../../../images/img_redirect.svg";

export const LotteryZero: React.FC = observer(() => {
    const {t} = useTranslation();
    const contextLayout = useContext(LayoutContext);

    const onClick = () => {
        window.open(
            decodeURI(
                "https://bezlimit.ru/free?utm_source=store&utm_medium=main+page&utm_campaign=free"
            ),
            "_blank"
        );
    };

    return (
        <Block className="bl-widget-lottery-zero">
            <Row gutter={[8, 8]}>
                <Col span={24}>
                    <Typography className="title">{t("Акция «Не плати за связь»")}</Typography>
                </Col>
                {_.gte(contextLayout?.width ?? 0, 821) ? (
                    <Col span={24}>
                        <Typography className="description">
                            {t("Клиенту — бесплатная связь,")}
                        </Typography>
                        <Typography className="description">{t("а вам — бонусы!")}</Typography>
                    </Col>
                ) : (
                    <Col span={24}>
                        <Typography className="description">
                            {t("Клиенту — бесплатная ")}
                        </Typography>
                        <Typography className="description">
                            {t("связь, а вам — бонусы!")}
                        </Typography>
                    </Col>
                )}

                <Col span={24} className="col-btn-linc">
                    <Button
                        type="primary"
                        className="btn-linck"
                        icon={<img src={imgRedirect} alt="" width={14} height={14} />}
                        onClick={onClick}
                    >
                        {t("Подробнее")}
                    </Button>
                </Col>
            </Row>
        </Block>
    );
});
